import { z } from 'zod';

import { zodCheckbox, zodSelectOption, zodStringOptional, zodStringRequired } from '@/shared/lib/validations';

import { DeliveryType } from '@/lib/consts';

const deliveryAddressFieldsSchema = z.object({
  indexNumber: zodStringRequired,
  region: zodSelectOption,
  district: zodSelectOption,
  city: zodSelectOption,
  street: zodSelectOption,
  warehouse: zodSelectOption,
  building: zodStringOptional,
  apartment: zodStringOptional,
  agreement: zodCheckbox,
  canBeDeliveredToAddress: zodCheckbox,
});

export const deliveryAddressSchema = z
  .object({
    deliveryType: zodSelectOption,
    indexNumber: z.any(),
    region: z.any(),
    district: z.any(),
    city: z.any(),
    street: z.any(),
    warehouse: z.any(),
    building: z.any(),
    apartment: z.any(),
    canBeDeliveredToAddress: z.any().optional(),
    agreement: zodCheckbox,
  })
  .superRefine((data, ctx) => {
    const deliveryType = data.deliveryType.id;

    if (deliveryType === DeliveryType.PERSONAL) {
      return;
    }

    const result = deliveryAddressFieldsSchema.safeParse(data);

    if (!result.success) {
      result.error.issues.forEach((issue) => {
        ctx.addIssue(issue);
      });
    }
  });
